<!--登录页面-->
<template>
    <div>
        <el-table
                :data="tableData"
                style="width: 100%">
            <el-table-column
                    prop="date"
                    label="日期"
                    width="180">
            </el-table-column>
            <el-table-column
                    prop="name"
                    label="姓名"
                    width="180">
            </el-table-column>
            <el-table-column
                    prop="address"
                    label="地址">
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    export default {
        name: 'MineIndex',
        data(){
            return {
                navArr:[
                    {name:"首页"},
                    {name:"组织结构"},
                    {name:"新闻资讯"},
                    {name:"通知公告"},
                    {name:"免费课程"},
                    {name:"星星展示"},
                    {name:"资质查询"}
                ],
                activeIndex:"登录",
                inputusername:"",   //用户名
                inputpassword:"",    //密码
                inputmobilphone:"",     //手机号码
                inputIdecode:"",        //验证码
                inputpasswordagain:"",   //再次输入密码
                getidecodeData:"获取验证码",
                inputdepartment:"",
                meta: {
                    'title': '',
                    'tabs': []
                },
                keepAlive: true,
                activeName: '',
                keepAliveInclude:  this.$route.meta.keepAlive ? this.$route.name : '',
                keepAliveArray:  this.$route.meta.keepAlive ? [this.$route.name] : [],

                isCollapsed: false,
                user:{
                    userRole:{

                    }
                },tableData: [{
                    date: '2016-05-02',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1518 弄'
                }, {
                    date: '2016-05-04',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1517 弄'
                }, {
                    date: '2016-05-01',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1519 弄'
                }, {
                    date: '2016-05-03',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1516 弄'
                }]

            }
        },
        watch:{
            getidecodeData(newval,oldval){
                if(newval==0){
                    this.getidecodeData="获取验证码";
                }
            }
        },
        methods:{
            handleSelect(val){
                this.activeIndex = val;
                this.inputusername="";
                this.inputpassword="";
                this.inputmobilphone="";
                this.inputIdecode="";
                this.inputpasswordagain="";
                this.inputdepartment="";
            },
            //登录点击事件
            loginFun(){
                if (this.inputusername.trim()==""||this.inputpassword.trim()==""||this.inputdepartment.trim()=="") {
                    this.$message({type:"error",message:"单位/用户名/密码不能为空"})
                    this.inputusername="";
                    this.inputpassword="";
                    return;
                }
                //发起请求判断密码账号 是否正确
            },
            //注册点击事件
            registerFun(){
                if (this.inputpasswordagain!=this.inputpassword) {
                    this.$message({type:"error",message:"密码确认错误"})
                    // this.inputusername="";
                    this.inputpassword="";
                    // this.inputdepartment="";
                    this.inputpasswordagain="";
                    return ;
                }
                if (this.inputusername.trim()==""||this.inputpassword.trim()==""||this.inputdepartment.trim()==""||this.inputpasswordagain.trim()=="") {
                    this.$message({type:"error",message:"内容不能为空"})
                    return;
                }
                //发起请求判断
            },
            //获取验证码 点击事件
            getidecodeFun(){
                if (this.getidecodeData=="获取验证码") {
                    this.getidecodeData=59;
                    var that=this;
                    var timetime;
                    timetime = setInterval(function() {
                        that.getidecodeData-=1;
                        if (that.getidecodeData<=0) {
                            clearInterval(timetime);
                        }
                    },1000)
                }

            }
        }
    }
</script>
<style lang="scss" scoped>

    // @font-face {
    //     /* font-properties */
    //     font-family: EuclidFlex-Bold;
    //     src:url('~@/assets/font/EuclidFlex-Bold.ttf');
    // }
    .login{
        height: 100vh;
        display: flex;
        flex-direction: column;
        position: relative;
        z-index: 1;
        .loginhead{
            height: 100px;
            width: 100vw;
            background: #1981FF;
            display: flex;
            justify-content: space-around;
            align-items: center;
            overflow: hidden;
            .headleft{
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
                width: 1240px;
                margin: 0 auto;
                // background: red;
                .logoAndname{
                    display: flex;
                    align-items: center;
                    width: 210px;
                    height: 40px;
                    background-size: cover;
                    -webkit-background-size: cover;
                }
                .headnav{
                    // margin-left: 80px;
                    margin-left: 0!important;
                    height: 100px;
                    line-height: 100px;
                    a{
                        font-size: 18px;
                        font-family: "Euclid Flex Bold",Arial,"PingFang SC",Verdana,"\5FAE\8F6F\96C5\9ED1";
                        font-weight: 400;
                        color: #FFFFFF;
                        margin-right: 24px;
                        &:hover{
                            font-weight:bold;
                        };
                    }
                }
                .headlefticon{
                    display: flex;
                    flex-direction: row;
                    width: 64px;
                    height:36px;
                    // margin-left: 80px;
                    margin-left: 0!important;
                    .headicon{
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        margin-left: 10px;
                        .loginbtn{
                            background: #4E81DF;
                            text-align: center;
                            height: 36px;
                            width: 64px;
                            line-height: 32px;
                            box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.3);
                            border-radius: 19px;
                            border: 2px solid #FFFFFF;
                            font-size: 16px;
                            
                            font-weight: 400;
                            color: #FFFFFF;
                            box-sizing: border-box;
                            &:hover{
                                cursor: pointer;
                                opacity: 0.8;
                                font-weight: bold;
                            };
                        }
                        .registerbtn{
                            background: #D22C46;
                        }
                    }
                }
            }
        }
        .logincontainer{
            flex: 1;
            position: relative;
            background: #F8F8F8;
            .logincontainerEntureWidth{
                max-width: 1240px;
                height: 100%;
                margin: 0 auto;
                position: relative;
                .bgitem{
                    width: 543px;
                    height: 569px;
                    background: url("~@/assets/images/login/pic-bg.png") center center no-repeat;
                    position: absolute;
                    top: 66px;
                    right: 697px;
                    background-size: cover;
                    -webkit-background-size: cover;
                }
                .logincontainerItem{
                    position: absolute;
                    right: 0;
                    top: 87px;
                    width: 452px;
                    background: #FFFFFF;
                    box-shadow: 0px 0px 34px 0px rgba(0,0,0,0.05);
                    border-radius: 9px;
                    padding:0 13px 0 17px;
                    box-sizing: border-box;
                    .elmenu{
                        margin-bottom: 53px;
                    }
                    /*公用部分leftLogin/rightRegister*/
                    .containerInput{
                        margin-top: 24px;
                        margin-left: 26px;
                        .inputTitle{
                            width: 65px;
                            height: 14px;
                            line-height: 14px;
                            display: inline-block;
                            /*margin-right: 18px;*/
                            line-height: 10px;
                            font-size: 16px;
                            
                            font-weight: 400;
                            color: #000000;
                            margin-right: 5px;
                        }
                    }
                    .tipsCommon{
                        margin-left: 98px;
                        margin-top: 32px;
                        
                        cursor: pointer;
                    }
                    .loginFont{
                        width: 95px;
                        height: 40px;
                        background: #0486FE;
                        border-radius: 4px;
                        text-align: center;
                        line-height: 40px;
                        font-size: 14px;
                        font-weight: 400;
                        color: #FFFFFF;
                        &:hover{
                            font-weight:bold;
                            opacity: 0.8;
                        };
                    }
                    .forget{
                        margin-top: 20px;
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        font-size: 14px;
                        font-weight: 400;
                        color: #999999;
                        margin-bottom: 32px;
                        .forgetpassword:hover{
                            font-weight:bold;
                        }
                        .forgetusername:hover{
                            font-weight:bold;
                        }
                    }
                    .leftLogin{
                        .containerInput{
                            .inputTitle{
                                width: 65px;
                            }
                        }
                    }
                    .rightRegister{
                        .containerInput{
                            .inputTitle{
                                width: 65px;
                            }
                            .getidecode{
                                width: 81px;
                                height: 34px;
                                text-align:center;
                                background: #E6F1FC;
                                border-radius: 3px;
                                border: 1px solid #A3D0FD;
                                font-size: 12px;
                                
                                font-weight: 400;
                                color: #1989FA;
                                line-height: 34px;
                                display: inline-block;
                                margin-left: 8px;
                                &:hover{
                                    font-weight:bold;
                                    opacity: 0.8;
                                    cursor: pointer;
                                };
                            }
                        }
                        .loginFont{
                            margin-bottom: 32px;
                        }
                    }

                }
            }

        }
    }

    .has-vertical-scrollerbar{ overflow:hidden; overflow-y:scroll;  }
    .has-vertical-scrollerbar::-webkit-scrollbar-track-piece,
    .has-vertical-scrollerbar::-webkit-scrollbar{ width: 0; }


    .is-active{
        font-size:16px;
        color:#000;
        font-weight:bold;
    }
    .inputidecode{
        .el-input__inner{
            padding-right:10px;
        }
    }

    .contain_warp{
        width: 1240px;
        margin:  0 auto;

    }
</style>



// WEBPACK FOOTER //
// MineIndex.vue?07d04bf7